;$(function () {
	$(document).on('click', '[data-toggle-filter]', function (e) {
		var $self = $(this);
		const target = $self.data('toggle-filter');

		var $targetEl = $('#'+target);

		if ($targetEl.length > 0 ) {
			$self.toggleClass('is-open');
			const toggleClass = $targetEl.data('toggle-target');

			e.preventDefault();
			$targetEl.toggleClass(toggleClass);
		}
	})
});
